const categoryTest = [
    { id: 1, category: "מבחן רכב פרטי (B)", ranks: './test/В', image: './car.png', note: 'В' },
    { id: 2, category: "מבחן אופנוע (A)", ranks: './test/A', image: './motorcycle.png', note: 'A' },
    { id: 3, category: "מבחן טקטור (1)", ranks: './test/1', image: './tractor.png', note: '1' },
    { id: 4, category: "מבחן רכב משא קל (C1)", ranks: './test/C1', image: './smalltruck.png', note: 'C1' },
    { id: 5, category: "מבחן רכב משא כבד (C)", ranks: './test/C', image: './truck.png', note: 'C' },
    { id: 6, category: "מבחן רכב ציבורי (D)", ranks: './test/D', image: './bus.png', note: 'D' }
]
export default categoryTest;